import React, { Component } from 'react';
import { Link } from 'react-router';
import classNames from 'classnames';
import moment from 'moment';
import calendar from 'lib/Calendar';
import has from 'lodash/has';

import DebounceInput from 'components/common/DebounceInput';

export default class CalendarFilter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchTerm: props.search || '',
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.showSearch && !nextProps.showSearch) {
      this.setState({ searchTerm: '' }, () => {
        nextProps.setEventsSearch('');
        nextProps.updateFilter(null, '');
      });
    }
  }

  render() {
    const { view, updateFilter, showSearch } = this.props;

    const showToday = has(this.props, 'showToday') ? this.props.showToday : true;
    const showViewPicker = has(this.props, 'showViewPicker') ? this.props.showViewPicker : true;

    const resetToToday = () => {
      updateFilter(calendar.filterFromMoment(moment()), this.state.searchTerm);
    };

    return (
      <span>
        {showSearch && (
          <div style={{ padding: 10, paddingBottom: 0 }}>
            <div className="input-group search-box">
              <DebounceInput
                label="Search Events"
                type="search"
                minLength={2}
                debounceTimeout={300}
                autoFocus
                initialValue={this.state.searchTerm}
                onChange={(event) => {
                  if (event.target.value !== this.state.searchTerm) {
                    this.setState({ searchTerm: event.target.value }, () => {
                      this.props.setEventsSearch(this.state.searchTerm);
                      updateFilter(null, this.state.searchTerm);
                    });
                  }
                }}
              />
            </div>
          </div>
        )}
        { (showToday || showViewPicker) && (
          <div className="mobile-view-picker">
            {showToday && (
              <div className="button-group">
                <a className="button today-button clickable" onClick={resetToToday}>Today</a>
              </div>
            )}
            {showViewPicker && (
              <div className="button-group">
                <Link
                  to="/calendar/day"
                  className={classNames({
                    button: true,
                    active: view === 'day',
                  })}
                >Day</Link>
                <Link
                  to="/calendar/week"
                  className={classNames({
                    button: true,
                    active: view === 'week',
                  })}
                >Week</Link>
                <Link
                  to="/calendar/month"
                  className={classNames({
                    button: true,
                    active: view === 'month',
                  })}
                >Month</Link>
                <Link
                  to="/calendar/list"
                  className={classNames({
                    button: true,
                    active: view === 'list',
                  })}
                >List</Link>
              </div>
            )}
          </div>
        )}
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/calendar/CalendarFilter.js